/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Ampli - A strong typed wrapper for your Analytics
 *
 * This file is generated by Amplitude.
 * To update run 'ampli pull clientarea'
 *
 * Required dependencies: @amplitude/analytics-browser@^1.3.0
 * Tracking Plan Version: 1
 * Build: 1.0.0
 * Runtime: browser:typescript-ampli-v2
 *
 * [View Tracking Plan](https://data.eu.amplitude.com/tickmill-634967/dev-bo01/events/main/latest)
 *
 * [Full Setup Instructions](https://data.eu.amplitude.com/tickmill-634967/dev-bo01/implementation/clientarea)
 */

import * as amplitude from '@amplitude/analytics-browser'

export type Environment = 'devbo01'

export const ApiKey: Record<Environment, string> = {
  devbo01: 'a4af744e9a61c4fbd282228cee36b31b',
}

/**
 * Default Amplitude configuration options. Contains tracking plan information.
 */
export const DefaultConfiguration: BrowserOptions = {
  plan: {
    version: '1',
    branch: 'main',
    source: 'clientarea',
    versionId: '5ba281be-4a56-4a07-9139-04ee9b0cebf6',
  },
  ...{
    ingestionMetadata: {
      sourceName: 'browser-typescript-ampli',
      sourceVersion: '2.0.0',
    },
  },
  serverZone: amplitude.Types.ServerZone.EU,
}

export interface LoadOptionsBase {
  disabled?: boolean
}

export type LoadOptionsWithEnvironment = LoadOptionsBase & {
  environment: Environment
  client?: { configuration?: BrowserOptions }
}
export type LoadOptionsWithApiKey = LoadOptionsBase & {
  client: { apiKey: string; configuration?: BrowserOptions }
}
export type LoadOptionsWithClientInstance = LoadOptionsBase & {
  client: { instance: BrowserClient }
}

export type LoadOptions =
  | LoadOptionsWithEnvironment
  | LoadOptionsWithApiKey
  | LoadOptionsWithClientInstance

export interface IdentifyProperties {
  tickmill_entity?: string
}

export interface CaLanguageChangedProperties {
  locale: string
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | en, it, pl, es, th, tr, ar, de, id, ko, ms, pt, vi, ru, zh, tw, hk, ja |
   */
  new_ca_language:
    | 'en'
    | 'it'
    | 'pl'
    | 'es'
    | 'th'
    | 'tr'
    | 'ar'
    | 'de'
    | 'id'
    | 'ko'
    | 'ms'
    | 'pt'
    | 'vi'
    | 'ru'
    | 'zh'
    | 'tw'
    | 'hk'
    | 'ja'
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | en, it, pl, es, th, tr, ar, de, id, ko, ms, pt, vi, ru, zh, tw, hk, ja |
   */
  previous_ca_language:
    | 'en'
    | 'it'
    | 'pl'
    | 'es'
    | 'th'
    | 'tr'
    | 'ar'
    | 'de'
    | 'id'
    | 'ko'
    | 'ms'
    | 'pt'
    | 'vi'
    | 'ru'
    | 'zh'
    | 'tw'
    | 'hk'
    | 'ja'
  route: string
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | en, it, pl, es, th, tr, ar, de, id, ko, ms, pt, vi, ru, zh, tw, hk, ja |
   */
  selected_ca_language:
    | 'en'
    | 'it'
    | 'pl'
    | 'es'
    | 'th'
    | 'tr'
    | 'ar'
    | 'de'
    | 'id'
    | 'ko'
    | 'ms'
    | 'pt'
    | 'vi'
    | 'ru'
    | 'zh'
    | 'tw'
    | 'hk'
    | 'ja'
}

export interface DepositAbandonedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | destination_method, amount_terms |
   */
  current_step: 'destination_method' | 'amount_terms'
}

export interface DepositAmountEnteredProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  amount: number
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | manual, preset |
   */
  amount_source: 'manual' | 'preset'
  currency: string
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | destination_method, amount_terms |
   */
  current_step: 'destination_method' | 'amount_terms'
  deposit_journey_id: string
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | wallet, ta, campaign_ta, transactions, menu_shortcut, menu_wallets, add_deposit_shortcut, first_time_deposit, notification, tour_guide, getting_started_slider, trade_markets_modal, subscriptions, balances, lucky_draw, direct_link, trade_header, campaign_account, getting_started_cfd, getting_started_etd, payment_agent, new_ta_add_funds |
   */
  entry_point:
    | 'wallet'
    | 'ta'
    | 'campaign_ta'
    | 'transactions'
    | 'menu_shortcut'
    | 'menu_wallets'
    | 'add_deposit_shortcut'
    | 'first_time_deposit'
    | 'notification'
    | 'tour_guide'
    | 'getting_started_slider'
    | 'trade_markets_modal'
    | 'subscriptions'
    | 'balances'
    | 'lucky_draw'
    | 'direct_link'
    | 'trade_header'
    | 'campaign_account'
    | 'getting_started_cfd'
    | 'getting_started_etd'
    | 'payment_agent'
    | 'new_ta_add_funds'
  locale: string
  notification_id?: string
  route: string
  source_page: string
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | TM EU, TM UK, TM SC, TM Partners, TM AS |
   */
  tickmill_entity: 'TM EU' | 'TM UK' | 'TM SC' | 'TM Partners' | 'TM AS'
}

export interface DepositDestinationSelectedProperties {
  currency: string
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | destination_method, amount_terms |
   */
  current_step: 'destination_method' | 'amount_terms'
  deposit_journey_id: string
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | wallet, trading-account |
   */
  destination: 'wallet' | 'trading-account'
  destination_id: string
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | wallet, ta, campaign_ta, transactions, menu_shortcut, menu_wallets, add_deposit_shortcut, first_time_deposit, notification, tour_guide, getting_started_slider, trade_markets_modal, subscriptions, balances, lucky_draw, direct_link, trade_header, campaign_account, getting_started_cfd, getting_started_etd, payment_agent, new_ta_add_funds |
   */
  entry_point:
    | 'wallet'
    | 'ta'
    | 'campaign_ta'
    | 'transactions'
    | 'menu_shortcut'
    | 'menu_wallets'
    | 'add_deposit_shortcut'
    | 'first_time_deposit'
    | 'notification'
    | 'tour_guide'
    | 'getting_started_slider'
    | 'trade_markets_modal'
    | 'subscriptions'
    | 'balances'
    | 'lucky_draw'
    | 'direct_link'
    | 'trade_header'
    | 'campaign_account'
    | 'getting_started_cfd'
    | 'getting_started_etd'
    | 'payment_agent'
    | 'new_ta_add_funds'
  locale: string
  notification_id?: string
  route: string
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | preset, manual |
   */
  selection_type: 'preset' | 'manual'
  source_page: string
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | TM EU, TM UK, TM SC, TM Partners, TM AS |
   */
  tickmill_entity: 'TM EU' | 'TM UK' | 'TM SC' | 'TM Partners' | 'TM AS'
}

export interface DepositFailedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | destination_method, amount_terms |
   */
  current_step: 'destination_method' | 'amount_terms'
  deposit_journey_id: string
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | wallet, ta, campaign_ta, transactions, menu_shortcut, menu_wallets, add_deposit_shortcut, first_time_deposit, notification, tour_guide, getting_started_slider, trade_markets_modal, subscriptions, balances, lucky_draw, direct_link, trade_header, campaign_account, getting_started_cfd, getting_started_etd, payment_agent, new_ta_add_funds |
   */
  entry_point:
    | 'wallet'
    | 'ta'
    | 'campaign_ta'
    | 'transactions'
    | 'menu_shortcut'
    | 'menu_wallets'
    | 'add_deposit_shortcut'
    | 'first_time_deposit'
    | 'notification'
    | 'tour_guide'
    | 'getting_started_slider'
    | 'trade_markets_modal'
    | 'subscriptions'
    | 'balances'
    | 'lucky_draw'
    | 'direct_link'
    | 'trade_header'
    | 'campaign_account'
    | 'getting_started_cfd'
    | 'getting_started_etd'
    | 'payment_agent'
    | 'new_ta_add_funds'
  locale: string
  message?: string
  notification_id?: string
  route: string
  source_page: string
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | TM EU, TM UK, TM SC, TM Partners, TM AS |
   */
  tickmill_entity: 'TM EU' | 'TM UK' | 'TM SC' | 'TM Partners' | 'TM AS'
}

export interface DepositMethodSelectedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | destination_method, amount_terms |
   */
  current_step: 'destination_method' | 'amount_terms'
  deposit_journey_id: string
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | wallet, ta, campaign_ta, transactions, menu_shortcut, menu_wallets, add_deposit_shortcut, first_time_deposit, notification, tour_guide, getting_started_slider, trade_markets_modal, subscriptions, balances, lucky_draw, direct_link, trade_header, campaign_account, getting_started_cfd, getting_started_etd, payment_agent, new_ta_add_funds |
   */
  entry_point:
    | 'wallet'
    | 'ta'
    | 'campaign_ta'
    | 'transactions'
    | 'menu_shortcut'
    | 'menu_wallets'
    | 'add_deposit_shortcut'
    | 'first_time_deposit'
    | 'notification'
    | 'tour_guide'
    | 'getting_started_slider'
    | 'trade_markets_modal'
    | 'subscriptions'
    | 'balances'
    | 'lucky_draw'
    | 'direct_link'
    | 'trade_header'
    | 'campaign_account'
    | 'getting_started_cfd'
    | 'getting_started_etd'
    | 'payment_agent'
    | 'new_ta_add_funds'
  is_last_used: boolean
  locale: string
  method_id: string
  method_type: string
  notification_id?: string
  provider: string
  route: string
  source_page: string
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | TM EU, TM UK, TM SC, TM Partners, TM AS |
   */
  tickmill_entity: 'TM EU' | 'TM UK' | 'TM SC' | 'TM Partners' | 'TM AS'
}

export interface DepositPaymentTermsConditionsOpenedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | destination_method, amount_terms |
   */
  current_step: 'destination_method' | 'amount_terms'
  deposit_journey_id: string
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | wallet, ta, campaign_ta, transactions, menu_shortcut, menu_wallets, add_deposit_shortcut, first_time_deposit, notification, tour_guide, getting_started_slider, trade_markets_modal, subscriptions, balances, lucky_draw, direct_link, trade_header, campaign_account, getting_started_cfd, getting_started_etd, payment_agent, new_ta_add_funds |
   */
  entry_point:
    | 'wallet'
    | 'ta'
    | 'campaign_ta'
    | 'transactions'
    | 'menu_shortcut'
    | 'menu_wallets'
    | 'add_deposit_shortcut'
    | 'first_time_deposit'
    | 'notification'
    | 'tour_guide'
    | 'getting_started_slider'
    | 'trade_markets_modal'
    | 'subscriptions'
    | 'balances'
    | 'lucky_draw'
    | 'direct_link'
    | 'trade_header'
    | 'campaign_account'
    | 'getting_started_cfd'
    | 'getting_started_etd'
    | 'payment_agent'
    | 'new_ta_add_funds'
  locale: string
  notification_id?: string
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  platform?: string
  route: string
  source_page: string
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | TM EU, TM UK, TM SC, TM Partners, TM AS |
   */
  tickmill_entity: 'TM EU' | 'TM UK' | 'TM SC' | 'TM Partners' | 'TM AS'
}

export interface DepositStartedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | destination_method, amount_terms |
   */
  current_step: 'destination_method' | 'amount_terms'
  deposit_journey_id: string
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | wallet, ta, campaign_ta, transactions, menu_shortcut, menu_wallets, add_deposit_shortcut, first_time_deposit, notification, tour_guide, getting_started_slider, trade_markets_modal, subscriptions, balances, lucky_draw, direct_link, trade_header, campaign_account, getting_started_cfd, getting_started_etd, payment_agent, new_ta_add_funds |
   */
  entry_point:
    | 'wallet'
    | 'ta'
    | 'campaign_ta'
    | 'transactions'
    | 'menu_shortcut'
    | 'menu_wallets'
    | 'add_deposit_shortcut'
    | 'first_time_deposit'
    | 'notification'
    | 'tour_guide'
    | 'getting_started_slider'
    | 'trade_markets_modal'
    | 'subscriptions'
    | 'balances'
    | 'lucky_draw'
    | 'direct_link'
    | 'trade_header'
    | 'campaign_account'
    | 'getting_started_cfd'
    | 'getting_started_etd'
    | 'payment_agent'
    | 'new_ta_add_funds'
  has_preset_ta: boolean
  has_preset_wallet: boolean
  locale: string
  notification_id?: string
  preset_ta_id?: string
  preset_wallet_id?: string
  route: string
  source_page: string
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | TM EU, TM UK, TM SC, TM Partners, TM AS |
   */
  tickmill_entity: 'TM EU' | 'TM UK' | 'TM SC' | 'TM Partners' | 'TM AS'
}

export interface DepositStepChangedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | destination_method, amount_terms |
   */
  current_step: 'destination_method' | 'amount_terms'
  deposit_journey_id: string
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | wallet, ta, campaign_ta, transactions, menu_shortcut, menu_wallets, add_deposit_shortcut, first_time_deposit, notification, tour_guide, getting_started_slider, trade_markets_modal, subscriptions, balances, lucky_draw, direct_link, trade_header, campaign_account, getting_started_cfd, getting_started_etd, payment_agent, new_ta_add_funds |
   */
  entry_point:
    | 'wallet'
    | 'ta'
    | 'campaign_ta'
    | 'transactions'
    | 'menu_shortcut'
    | 'menu_wallets'
    | 'add_deposit_shortcut'
    | 'first_time_deposit'
    | 'notification'
    | 'tour_guide'
    | 'getting_started_slider'
    | 'trade_markets_modal'
    | 'subscriptions'
    | 'balances'
    | 'lucky_draw'
    | 'direct_link'
    | 'trade_header'
    | 'campaign_account'
    | 'getting_started_cfd'
    | 'getting_started_etd'
    | 'payment_agent'
    | 'new_ta_add_funds'
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | wallet_method, amount_terms |
   */
  from_step: 'wallet_method' | 'amount_terms'
  locale: string
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | forward, backward |
   */
  navigation_direction: 'forward' | 'backward'
  notification_id?: string
  route: string
  source_page: string
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | TM EU, TM UK, TM SC, TM Partners, TM AS |
   */
  tickmill_entity: 'TM EU' | 'TM UK' | 'TM SC' | 'TM Partners' | 'TM AS'
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | wallet_method, amount_terms |
   */
  to_step: 'wallet_method' | 'amount_terms'
}

export interface DepositSubmittedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | destination_method, amount_terms |
   */
  current_step: 'destination_method' | 'amount_terms'
  deposit_id: string
  deposit_journey_id: string
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | wallet, ta, campaign_ta, transactions, menu_shortcut, menu_wallets, add_deposit_shortcut, first_time_deposit, notification, tour_guide, getting_started_slider, trade_markets_modal, subscriptions, balances, lucky_draw, direct_link, trade_header, campaign_account, getting_started_cfd, getting_started_etd, payment_agent, new_ta_add_funds |
   */
  entry_point:
    | 'wallet'
    | 'ta'
    | 'campaign_ta'
    | 'transactions'
    | 'menu_shortcut'
    | 'menu_wallets'
    | 'add_deposit_shortcut'
    | 'first_time_deposit'
    | 'notification'
    | 'tour_guide'
    | 'getting_started_slider'
    | 'trade_markets_modal'
    | 'subscriptions'
    | 'balances'
    | 'lucky_draw'
    | 'direct_link'
    | 'trade_header'
    | 'campaign_account'
    | 'getting_started_cfd'
    | 'getting_started_etd'
    | 'payment_agent'
    | 'new_ta_add_funds'
  locale: string
  notification_id?: string
  route: string
  source_page: string
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | TM EU, TM UK, TM SC, TM Partners, TM AS |
   */
  tickmill_entity: 'TM EU' | 'TM UK' | 'TM SC' | 'TM Partners' | 'TM AS'
}

export interface DepositTermsAcceptedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | disclaimer_liability, terms_and_conditions |
   */
  checkbox_type: 'disclaimer_liability' | 'terms_and_conditions'
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | destination_method, amount_terms |
   */
  current_step: 'destination_method' | 'amount_terms'
  deposit_journey_id: string
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | wallet, ta, campaign_ta, transactions, menu_shortcut, menu_wallets, add_deposit_shortcut, first_time_deposit, notification, tour_guide, getting_started_slider, trade_markets_modal, subscriptions, balances, lucky_draw, direct_link, trade_header, campaign_account, getting_started_cfd, getting_started_etd, payment_agent, new_ta_add_funds |
   */
  entry_point:
    | 'wallet'
    | 'ta'
    | 'campaign_ta'
    | 'transactions'
    | 'menu_shortcut'
    | 'menu_wallets'
    | 'add_deposit_shortcut'
    | 'first_time_deposit'
    | 'notification'
    | 'tour_guide'
    | 'getting_started_slider'
    | 'trade_markets_modal'
    | 'subscriptions'
    | 'balances'
    | 'lucky_draw'
    | 'direct_link'
    | 'trade_header'
    | 'campaign_account'
    | 'getting_started_cfd'
    | 'getting_started_etd'
    | 'payment_agent'
    | 'new_ta_add_funds'
  locale: string
  notification_id?: string
  route: string
  source_page: string
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | TM EU, TM UK, TM SC, TM Partners, TM AS |
   */
  tickmill_entity: 'TM EU' | 'TM UK' | 'TM SC' | 'TM Partners' | 'TM AS'
}

export interface NotificationClosedProperties {
  locale: string
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | within_1_day, after_1_day |
   */
  notification_engagement_timing: 'within_1_day' | 'after_1_day'
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | notification_center, external |
   */
  notification_entry_point: 'notification_center' | 'external'
  notification_id?: string
  notification_name: string
  route: string
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | TM EU, TM UK, TM SC, TM Partners, TM AS |
   */
  tickmill_entity: 'TM EU' | 'TM UK' | 'TM SC' | 'TM Partners' | 'TM AS'
}

export interface NotificationReadMoreProperties {
  locale: string
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | within_1_day, after_1_day |
   */
  notification_engagement_timing: 'within_1_day' | 'after_1_day'
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | notification_center, external |
   */
  notification_entry_point: 'notification_center' | 'external'
  notification_id?: string
  notification_name: string
  route: string
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | TM EU, TM UK, TM SC, TM Partners, TM AS |
   */
  tickmill_entity: 'TM EU' | 'TM UK' | 'TM SC' | 'TM Partners' | 'TM AS'
}

export interface NotificationShownProperties {
  locale: string
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | within_1_day, after_1_day |
   */
  notification_engagement_timing: 'within_1_day' | 'after_1_day'
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | notification_center, external |
   */
  notification_entry_point: 'notification_center' | 'external'
  notification_id?: string
  notification_name: string
  route: string
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | TM EU, TM UK, TM SC, TM Partners, TM AS |
   */
  tickmill_entity: 'TM EU' | 'TM UK' | 'TM SC' | 'TM Partners' | 'TM AS'
}

export interface ThemeChangedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | light, dark, auto |
   */
  new_theme: 'light' | 'dark' | 'auto'
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | light, dark, auto |
   */
  previous_theme: 'light' | 'dark' | 'auto'
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | preferences, header |
   */
  theme_changed_source: 'preferences' | 'header'
}

export interface WithdrawalPaymentTermsConditionsOpenedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | destination_method, amount_terms |
   */
  current_step: 'destination_method' | 'amount_terms'
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | wallet, ta, campaign_ta, transactions, menu_shortcut, menu_wallets, add_deposit_shortcut, first_time_deposit, notification, tour_guide, getting_started_slider, trade_markets_modal, subscriptions, balances, lucky_draw, direct_link, trade_header, campaign_account, getting_started_cfd, getting_started_etd, payment_agent, new_ta_add_funds |
   */
  entry_point:
    | 'wallet'
    | 'ta'
    | 'campaign_ta'
    | 'transactions'
    | 'menu_shortcut'
    | 'menu_wallets'
    | 'add_deposit_shortcut'
    | 'first_time_deposit'
    | 'notification'
    | 'tour_guide'
    | 'getting_started_slider'
    | 'trade_markets_modal'
    | 'subscriptions'
    | 'balances'
    | 'lucky_draw'
    | 'direct_link'
    | 'trade_header'
    | 'campaign_account'
    | 'getting_started_cfd'
    | 'getting_started_etd'
    | 'payment_agent'
    | 'new_ta_add_funds'
  locale: string
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  platform?: string
  route: string
  source_page: string
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | TM EU, TM UK, TM SC, TM Partners, TM AS |
   */
  tickmill_entity: 'TM EU' | 'TM UK' | 'TM SC' | 'TM Partners' | 'TM AS'
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  withdrawal_journey_id?: string
}

export interface DepositSharedContextProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | destination_method, amount_terms |
   */
  current_step: 'destination_method' | 'amount_terms'
  deposit_journey_id: string
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | wallet, ta, campaign_ta, transactions, menu_shortcut, menu_wallets, add_deposit_shortcut, first_time_deposit, notification, tour_guide, getting_started_slider, trade_markets_modal, subscriptions, balances, lucky_draw, direct_link, trade_header, campaign_account, getting_started_cfd, getting_started_etd, payment_agent, new_ta_add_funds |
   */
  entry_point:
    | 'wallet'
    | 'ta'
    | 'campaign_ta'
    | 'transactions'
    | 'menu_shortcut'
    | 'menu_wallets'
    | 'add_deposit_shortcut'
    | 'first_time_deposit'
    | 'notification'
    | 'tour_guide'
    | 'getting_started_slider'
    | 'trade_markets_modal'
    | 'subscriptions'
    | 'balances'
    | 'lucky_draw'
    | 'direct_link'
    | 'trade_header'
    | 'campaign_account'
    | 'getting_started_cfd'
    | 'getting_started_etd'
    | 'payment_agent'
    | 'new_ta_add_funds'
  locale: string
  notification_id?: string
  route: string
  source_page: string
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | TM EU, TM UK, TM SC, TM Partners, TM AS |
   */
  tickmill_entity: 'TM EU' | 'TM UK' | 'TM SC' | 'TM Partners' | 'TM AS'
}

export interface NotificationSharedContextProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | within_1_day, after_1_day |
   */
  notification_engagement_timing: 'within_1_day' | 'after_1_day'
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | notification_center, external |
   */
  notification_entry_point: 'notification_center' | 'external'
  notification_id?: string
  notification_name: string
}

export class Identify implements BaseEvent {
  event_type = amplitude.Types.SpecialEventType.IDENTIFY

  constructor(public event_properties?: IdentifyProperties) {
    this.event_properties = event_properties
  }
}

export class CaLanguageChanged implements BaseEvent {
  event_type = 'CA language changed'

  constructor(public event_properties: CaLanguageChangedProperties) {
    this.event_properties = event_properties
  }
}

export class DepositAbandoned implements BaseEvent {
  event_type = 'Deposit abandoned'

  constructor(public event_properties: DepositAbandonedProperties) {
    this.event_properties = event_properties
  }
}

export class DepositAmountEntered implements BaseEvent {
  event_type = 'Deposit amount entered'

  constructor(public event_properties: DepositAmountEnteredProperties) {
    this.event_properties = event_properties
  }
}

export class DepositDestinationSelected implements BaseEvent {
  event_type = 'Deposit destination selected'

  constructor(public event_properties: DepositDestinationSelectedProperties) {
    this.event_properties = event_properties
  }
}

export class DepositFailed implements BaseEvent {
  event_type = 'Deposit failed'

  constructor(public event_properties: DepositFailedProperties) {
    this.event_properties = event_properties
  }
}

export class DepositMethodSelected implements BaseEvent {
  event_type = 'Deposit method selected'

  constructor(public event_properties: DepositMethodSelectedProperties) {
    this.event_properties = event_properties
  }
}

export class DepositPaymentTermsConditionsOpened implements BaseEvent {
  event_type = 'Deposit payment terms & conditions opened'

  constructor(public event_properties: DepositPaymentTermsConditionsOpenedProperties) {
    this.event_properties = event_properties
  }
}

export class DepositStarted implements BaseEvent {
  event_type = 'Deposit started'

  constructor(public event_properties: DepositStartedProperties) {
    this.event_properties = event_properties
  }
}

export class DepositStepChanged implements BaseEvent {
  event_type = 'Deposit step changed'

  constructor(public event_properties: DepositStepChangedProperties) {
    this.event_properties = event_properties
  }
}

export class DepositSubmitted implements BaseEvent {
  event_type = 'Deposit submitted'

  constructor(public event_properties: DepositSubmittedProperties) {
    this.event_properties = event_properties
  }
}

export class DepositTermsAccepted implements BaseEvent {
  event_type = 'Deposit terms accepted'

  constructor(public event_properties: DepositTermsAcceptedProperties) {
    this.event_properties = event_properties
  }
}

export class NotificationClosed implements BaseEvent {
  event_type = 'Notification closed'

  constructor(public event_properties: NotificationClosedProperties) {
    this.event_properties = event_properties
  }
}

export class NotificationReadMore implements BaseEvent {
  event_type = 'Notification read more'

  constructor(public event_properties: NotificationReadMoreProperties) {
    this.event_properties = event_properties
  }
}

export class NotificationShown implements BaseEvent {
  event_type = 'Notification shown'

  constructor(public event_properties: NotificationShownProperties) {
    this.event_properties = event_properties
  }
}

export class ThemeChanged implements BaseEvent {
  event_type = 'Theme Changed'

  constructor(public event_properties: ThemeChangedProperties) {
    this.event_properties = event_properties
  }
}

export class WithdrawalPaymentTermsConditionsOpened implements BaseEvent {
  event_type = 'Withdrawal payment terms & conditions opened'

  constructor(public event_properties: WithdrawalPaymentTermsConditionsOpenedProperties) {
    this.event_properties = event_properties
  }
}

export type PromiseResult<T> = { promise: Promise<T | void> }

const getVoidPromiseResult = () => ({ promise: Promise.resolve() })

// prettier-ignore
export class Ampli {
  private disabled: boolean = false;
  private amplitude?: BrowserClient;

  get client(): BrowserClient {
    this.isInitializedAndEnabled();
    return this.amplitude!;
  }

  get isLoaded(): boolean {
    return this.amplitude != null;
  }

  private isInitializedAndEnabled(): boolean {
    if (!this.amplitude) {
      console.error('ERROR: Ampli is not yet initialized. Have you called ampli.load() on app start?');
      return false;
    }
    return !this.disabled;
  }

  /**
   * Initialize the Ampli SDK. Call once when your application starts.
   *
   * @param options Configuration options to initialize the Ampli SDK with.
   */
  load(options: LoadOptions): PromiseResult<void> {
    this.disabled = options.disabled ?? false;

    if (this.amplitude) {
      console.warn('WARNING: Ampli is already intialized. Ampli.load() should be called once at application startup.');
      return getVoidPromiseResult();
    }

    let apiKey: string | null = null;
    if (options.client && 'apiKey' in options.client) {
      apiKey = options.client.apiKey;
    } else if ('environment' in options) {
      apiKey = ApiKey[options.environment];
    }

    if (options.client && 'instance' in options.client) {
      this.amplitude = options.client.instance;
    } else if (apiKey) {
      this.amplitude = amplitude.createInstance();
      const configuration = (options.client && 'configuration' in options.client) ? options.client.configuration : {};
      return this.amplitude.init(apiKey, undefined, { ...DefaultConfiguration, ...configuration });
    } else {
      console.error("ERROR: ampli.load() requires 'environment', 'client.apiKey', or 'client.instance'");
    }

    return getVoidPromiseResult();
  }

  /**
   * Identify a user and set user properties.
   *
   * @param userId The user's id.
   * @param properties The user properties.
   * @param options Optional event options.
   */
  identify(
    userId: string | undefined,
    properties?: IdentifyProperties,
    options?: EventOptions,
  ): PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    if (userId) {
      options = {...options,  user_id: userId};
    }

    const amplitudeIdentify = new amplitude.Identify();
    const eventProperties = properties;
    if (eventProperties != null) {
      for (const [key, value] of Object.entries(eventProperties)) {
        amplitudeIdentify.set(key, value);
      }
    }
    return this.amplitude!.identify(
      amplitudeIdentify,
      options,
    );
  }

 /**
  * Flush the event.
  */
  flush() : PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    return this.amplitude!.flush();
  }

  /**
   * Track event
   *
   * @param event The event to track.
   * @param options Optional event options.
   */
  track(event: Event, options?: EventOptions): PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    return this.amplitude!.track(event, undefined, options);
  }

  /**
   * CA language changed
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/tickmill-634967/dev-bo01/events/main/latest/CA%20language%20changed)
   *
   * Triggered when the user changes the language setting in the Client Area (CA).
   *
   * @param properties The event's properties (e.g. locale)
   * @param options Amplitude event options.
   */
  caLanguageChanged(
    properties: CaLanguageChangedProperties,
    options?: EventOptions,
  ) {
    return this.track(new CaLanguageChanged(properties), options);
  }

  /**
   * Deposit abandoned
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/tickmill-634967/dev-bo01/events/main/latest/Deposit%20abandoned)
   *
   * This event represents a user initiating a deposit process but abandoning and failing to complete it. It is triggered when the user exits or abandons the deposit funnel before finalizing the transaction.
   *
   * Owner: Anna Kantzia
   *
   * @param properties The event's properties (e.g. current_step)
   * @param options Amplitude event options.
   */
  depositAbandoned(
    properties: DepositAbandonedProperties,
    options?: EventOptions,
  ) {
    return this.track(new DepositAbandoned(properties), options);
  }

  /**
   * Deposit amount entered
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/tickmill-634967/dev-bo01/events/main/latest/Deposit%20amount%20entered)
   *
   * This event represents the user entering a deposit amount during the deposit process. It is triggered immediately when the user inputs or modifies the amount value in the deposit field.
   *
   * Owner: Anna Kantzia
   *
   * @param properties The event's properties (e.g. amount)
   * @param options Amplitude event options.
   */
  depositAmountEntered(
    properties: DepositAmountEnteredProperties,
    options?: EventOptions,
  ) {
    return this.track(new DepositAmountEntered(properties), options);
  }

  /**
   * Deposit destination selected
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/tickmill-634967/dev-bo01/events/main/latest/Deposit%20destination%20selected)
   *
   * Client initiated the deposit flow.
   *
   * Owner: Anna Kantzia
   *
   * @param properties The event's properties (e.g. currency)
   * @param options Amplitude event options.
   */
  depositDestinationSelected(
    properties: DepositDestinationSelectedProperties,
    options?: EventOptions,
  ) {
    return this.track(new DepositDestinationSelected(properties), options);
  }

  /**
   * Deposit failed
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/tickmill-634967/dev-bo01/events/main/latest/Deposit%20failed)
   *
   * This event represents a user’s attempt to make a deposit that was unsuccessful due to an error or failure in the transaction process. It is triggered immediately when the system detects that the deposit could not be completed.
   *
   * Owner: Anna Kantzia
   *
   * @param properties The event's properties (e.g. current_step)
   * @param options Amplitude event options.
   */
  depositFailed(
    properties: DepositFailedProperties,
    options?: EventOptions,
  ) {
    return this.track(new DepositFailed(properties), options);
  }

  /**
   * Deposit method selected
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/tickmill-634967/dev-bo01/events/main/latest/Deposit%20method%20selected)
   *
   * This event records when a user selects a deposit method during the deposit process. It is triggered immediately after the user chooses their preferred payment option within the Deposit Funnel.
   *
   * Owner: Anna Kantzia
   *
   * @param properties The event's properties (e.g. current_step)
   * @param options Amplitude event options.
   */
  depositMethodSelected(
    properties: DepositMethodSelectedProperties,
    options?: EventOptions,
  ) {
    return this.track(new DepositMethodSelected(properties), options);
  }

  /**
   * Deposit payment terms & conditions opened
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/tickmill-634967/dev-bo01/events/main/latest/Deposit%20payment%20terms%20%26%20conditions%20opened)
   *
   * This event represents the user opening the terms and conditions documents related to deposit requests.
   *
   * @param properties The event's properties (e.g. current_step)
   * @param options Amplitude event options.
   */
  depositPaymentTermsConditionsOpened(
    properties: DepositPaymentTermsConditionsOpenedProperties,
    options?: EventOptions,
  ) {
    return this.track(new DepositPaymentTermsConditionsOpened(properties), options);
  }

  /**
   * Deposit started
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/tickmill-634967/dev-bo01/events/main/latest/Deposit%20started)
   *
   * This event represents the initiation of the deposit process by the user. It is triggered when a user begins to submit a deposit request within the application.
   *
   * Owner: Anna Kantzia
   *
   * @param properties The event's properties (e.g. current_step)
   * @param options Amplitude event options.
   */
  depositStarted(
    properties: DepositStartedProperties,
    options?: EventOptions,
  ) {
    return this.track(new DepositStarted(properties), options);
  }

  /**
   * Deposit step changed
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/tickmill-634967/dev-bo01/events/main/latest/Deposit%20step%20changed)
   *
   * This event tracks when a user advances to a different step within the deposit process. It is triggered each time the deposit funnel step changes, capturing the user's progress through the deposit workflow.
   *
   * Owner: Anna Kantzia
   *
   * @param properties The event's properties (e.g. current_step)
   * @param options Amplitude event options.
   */
  depositStepChanged(
    properties: DepositStepChangedProperties,
    options?: EventOptions,
  ) {
    return this.track(new DepositStepChanged(properties), options);
  }

  /**
   * Deposit submitted
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/tickmill-634967/dev-bo01/events/main/latest/Deposit%20submitted)
   *
   * This event represents the user completing and submitting a deposit request within the deposit funnel. It is triggered when the user finalizes the deposit form and initiates the transaction process.
   *
   * Owner: Anna Kantzia
   *
   * @param properties The event's properties (e.g. current_step)
   * @param options Amplitude event options.
   */
  depositSubmitted(
    properties: DepositSubmittedProperties,
    options?: EventOptions,
  ) {
    return this.track(new DepositSubmitted(properties), options);
  }

  /**
   * Deposit terms accepted
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/tickmill-634967/dev-bo01/events/main/latest/Deposit%20terms%20accepted)
   *
   * This event represents the user agreeing to the terms and conditions associated with making a deposit. It is triggered when the user explicitly accepts the deposit terms during the deposit process.
   *
   * Owner: Anna Kantzia
   *
   * @param properties The event's properties (e.g. checkbox_type)
   * @param options Amplitude event options.
   */
  depositTermsAccepted(
    properties: DepositTermsAcceptedProperties,
    options?: EventOptions,
  ) {
    return this.track(new DepositTermsAccepted(properties), options);
  }

  /**
   * Notification closed
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/tickmill-634967/dev-bo01/events/main/latest/Notification%20closed)
   *
   * This event represents the action when a user closes a notification within the application.
   *
   * @param properties The event's properties (e.g. locale)
   * @param options Amplitude event options.
   */
  notificationClosed(
    properties: NotificationClosedProperties,
    options?: EventOptions,
  ) {
    return this.track(new NotificationClosed(properties), options);
  }

  /**
   * Notification read more
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/tickmill-634967/dev-bo01/events/main/latest/Notification%20read%20more)
   *
   * This event is triggered when a user selects the option to read more details within a notification. It captures the action of expanding or accessing additional information related to a notification message.
   *
   * @param properties The event's properties (e.g. locale)
   * @param options Amplitude event options.
   */
  notificationReadMore(
    properties: NotificationReadMoreProperties,
    options?: EventOptions,
  ) {
    return this.track(new NotificationReadMore(properties), options);
  }

  /**
   * Notification shown
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/tickmill-634967/dev-bo01/events/main/latest/Notification%20shown)
   *
   * This event represents the system displaying a notification to the user. It is triggered each time a notification message appears on the user interface, indicating important information or updates.
   *
   * @param properties The event's properties (e.g. locale)
   * @param options Amplitude event options.
   */
  notificationShown(
    properties: NotificationShownProperties,
    options?: EventOptions,
  ) {
    return this.track(new NotificationShown(properties), options);
  }

  /**
   * Theme Changed
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/tickmill-634967/dev-bo01/events/main/latest/Theme%20Changed)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. new_theme)
   * @param options Amplitude event options.
   */
  themeChanged(
    properties: ThemeChangedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ThemeChanged(properties), options);
  }

  /**
   * Withdrawal payment terms & conditions opened
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/tickmill-634967/dev-bo01/events/main/latest/Withdrawal%20payment%20terms%20%26%20conditions%20opened)
   *
   * This event represents the user opening the terms and conditions documents related to withdrawal requests.
   *
   * @param properties The event's properties (e.g. current_step)
   * @param options Amplitude event options.
   */
  withdrawalPaymentTermsConditionsOpened(
    properties: WithdrawalPaymentTermsConditionsOpenedProperties,
    options?: EventOptions,
  ) {
    return this.track(new WithdrawalPaymentTermsConditionsOpened(properties), options);
  }
}

export const ampli = new Ampli()

// BASE TYPES
type BrowserOptions = amplitude.Types.BrowserOptions

export type BrowserClient = amplitude.Types.BrowserClient
export type BaseEvent = amplitude.Types.BaseEvent
export type IdentifyEvent = amplitude.Types.IdentifyEvent
export type GroupEvent = amplitude.Types.GroupIdentifyEvent
export type Event = amplitude.Types.Event
export type EventOptions = amplitude.Types.EventOptions
export type Result = amplitude.Types.Result
